export const getFileSize = (bytes) => {
    let fileSize = null;

    if      (bytes >= 1000000000) { fileSize = (bytes / 1000000000).toFixed(1) + " GB"; }
    else if (bytes >= 1000000)    { fileSize = (bytes / 1000000).toFixed(1) + " MB"; }
    else if (bytes >= 1000)       { fileSize = (bytes / 1000).toFixed(1) + " KB"; }
    else if (bytes > 1)           { fileSize = bytes + " bytes"; }
    else if (bytes == 1)          { fileSize = bytes + " byte"; }
    else { fileSize = "0 bytes"; }

    return fileSize;
}


